import { useFormikContext } from 'formik'

import { FormFieldsContainer, FormFieldsDeadline } from '../../../Form'
import {
  FormikEntityActionConfigFields,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../Formik'
import { TASK_FORM_DEADLINE_FIELD_NAME } from '../../TaskForm'
import { TASK_EDIT_DEADLINE_FIELDS_INITIAL_VALUES } from '../TaskEditDeadlineModal.constants'

function FormFields({ actionTypes, typeSelectProps, ...restProps }) {
  const { errors } = useFormikContext()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: TASK_EDIT_DEADLINE_FIELDS_INITIAL_VALUES,
    })

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          ...typeSelectProps,
          error: errors[TASK_FORM_DEADLINE_FIELD_NAME],
          options: actionTypes,
        }}
      >
        <FormFieldsDeadline
          {...restProps}
          deadlineFieldName={TASK_FORM_DEADLINE_FIELD_NAME}
          disabled={actionTypeValueIsRemoveAll}
          inputDateLabel='Task.EditDeadlineFieldDateLabelKey'
          inputDatePlaceholder='Task.EditDeadlineFieldDatePlaceholderKey'
          inputTimeLabel='Task.EditDeadlineFieldTimeLabelKey'
          inputTimePlaceholder='Taks.EditDeadlineFieldTimePlaceholderKey'
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default FormFields
